import store from 'store2';

export const erLocalStore = store.namespace('electricRoutes');
